import { Reveal, SectionHeading } from "./Reveal";
import { MapPin } from "lucide-react";
import { resolveMediaUrl } from "@/lib/api";

const spans = ["md:col-span-2 md:row-span-2", "", "", "md:col-span-2", "", ""];

export const Attractions = ({ attractions = [] }) => (
  <section id="things-to-do" className="bg-[#F8F6F0] py-20 md:py-28" data-testid="attractions-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-14">
        <SectionHeading eyebrow="Explore the Town" title="Things to Do in Eufaula" testId="attractions" />
      </div>
      <div className="grid md:grid-cols-4 gap-5 auto-rows-[240px]">
        {attractions.map((a, i) => (
          <Reveal key={a.id || a.name} delay={(i % 3) * 0.08} className={spans[i % spans.length]}>
            <div className="group relative w-full h-full rounded-2xl overflow-hidden" data-testid={`attraction-card-${a.id || i}`}>
              <img src={resolveMediaUrl(a.image)} alt={a.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/90 via-[#0A192F]/25 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold">{a.category}</span>
                <h3 className="font-serif-display text-xl sm:text-2xl font-semibold text-[#F8F6F0] mt-1">{a.name}</h3>
                <p className="text-[#F8F6F0]/70 text-xs sm:text-sm mt-1.5 leading-relaxed max-h-0 opacity-0 group-hover:max-h-32 group-hover:opacity-100 transition-all duration-500 overflow-hidden">
                  {a.description}
                </p>
                {a.distance && (
                  <p className="text-[#C5A059] text-xs mt-2 flex items-center gap-1"><MapPin size={11} /> {a.distance} from the hotel</p>
                )}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
